import {
  HiOutlineBuildingOffice2,
  HiOutlineEnvelope,
  HiOutlineQueueList,
  HiOutlineSquares2X2,
  HiOutlineRectangleGroup,
  HiOutlineClock,
} from "react-icons/hi2";

export const ADMIN_MENU_ITEMS_RAW = [
  {
    path: "/admin/dashboard/tenants",
    label: "Manage Tenants",
    icon: HiOutlineBuildingOffice2,
    key: "admin-tenants",
  },
  {
    path: "/admin/dashboard/workspace-overview",
    label: "Workspace Overview",
    icon: HiOutlineSquares2X2,
    key: "admin-workspace-overview",
  },
  {
    path: "/admin/dashboard/feature-apps",
    label: "Feature apps",
    icon: HiOutlineRectangleGroup,
    key: "admin-feature-apps",
  },
  {
    path: "/admin/dashboard/email-templates",
    label: "Email Templates",
    icon: HiOutlineEnvelope,
    key: "admin-email-templates",
  },
  {
    path: "/admin/dashboard/message-queue",
    label: "Message Queue",
    icon: HiOutlineQueueList,
    key: "admin-message-queue",
    permissionCode: "MessageQueue.View",
  },
  {
    path: "/admin/dashboard/activity-log",
    label: "Activity Log",
    icon: HiOutlineClock,
    key: "admin-activity-log",
  },
];

export function flattenAdminNavForPalette(ctx) {
  const { hasPermission } = ctx;
  return ADMIN_MENU_ITEMS_RAW.filter(
    (item) =>
      !item.permissionCode || hasPermission(item.permissionCode),
  ).map((item) => ({
    id: item.key,
    path: item.path,
    label: item.label,
    group: "Admin",
  }));
}
